import { render, staticRenderFns } from "./datajob-record-detail.vue?vue&type=template&id=4dc4452e&scoped=true&"
import script from "./datajob-record-detail.vue?vue&type=script&lang=ts&"
export * from "./datajob-record-detail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc4452e",
  null
  
)

export default component.exports